/**
 * A count as the screen shows it. Unknown — still loading, or the request
 * failed — is "—", never 0: a zero that is really "not counted yet" tells a
 * bench there is nothing to do.
 */
export function countText(n: number | null | undefined): string {
  return typeof n === 'number' && Number.isFinite(n) ? n.toLocaleString('en-IN') : '—';
}

/** "12 of 40 matching" while more remain to load; just "40" once all are shown. */
export function loadedOf(loaded: number, matching: number | null | undefined): string {
  if (typeof matching !== 'number') return `${loaded} loaded`;
  return loaded >= matching ? `${matching} matching` : `Showing ${loaded} of ${matching} matching`;
}
